import settingsColor from "~/assets/Icons/colored-settings.svg"
import coloredTranslations from "~/assets/Icons/colored-translations.svg"
import settings from "~/assets/Icons/settings.svg"
import translations from "~/assets/Icons/translations.svg"

export const DOCS_TYPES = [
  {
    name: "All Docs",
    id: "",
  },
  {
    name: "Guide",
    id: "guide",
  },
  {
    name: "Assessment",
    id: "assessment",
  },
  {
    name: "Checklist",
    id: "checklist",
  },
  {
    name: "Course Bytes",
    id: "course-bytes",
  },
  {
    name: "Flow Chart",
    id: "flow-chart",
  },
  {
    name: "How-to Guide",
    id: "how-to-guide",
  },
  {
    name: "Resource",
    id: "resource",
  },
  {
    name: "Worksheet",
    id: "worksheet",
  },
  {
    name: "Playbook",
    id: "playbook",
  },
  {
    name: "Courses",
    id: "courses",
  },
  {
    name: "Video Guide",
    id: "video-guide",
  },
  {
    name: "Article",
    id: "article",
  },
]

export const DEFAULT_OPTIONS = {
  page: 1,
  per_page: 10,
  type: "",
  search: "",
}

export const DOC_TABS = [
  {
    label: "DETAILS",
    id: "details",
    activeIcon: settingsColor,
    icon: settings,
  },
  {
    label: "TRANSLATIONS",
    id: "translations",
    activeIcon: coloredTranslations,
    icon: translations,
  },
]
